export { default as Room } from './Room';
export { default as Facility } from './Facility';
export { default as BeautyPerfect } from './BeautyPerfect';
export { default as MommyBabyBanner } from './MommyBabyBanner';


// WEBPACK FOOTER //
// ./src/client/components/tour/index.js